var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponent, SimpleShouldUpdate } from "react-vextensions";
import { VReactMarkdown_Remarkable, PageContainer } from "vwebapp-framework";
const pageText = `
### Other websites

* [Debate Map](https://debatemap.live): Tree-based mapping of beliefs, arguments, and evidence.
`;
let LinksUI = class LinksUI extends BaseComponent {
    render() {
        const { page, match } = this.props;
        return (React.createElement(PageContainer, { scrollable: true },
            React.createElement("article", { className: "selectableAC" },
                React.createElement(VReactMarkdown_Remarkable, { source: pageText }))));
    }
};
LinksUI = __decorate([
    SimpleShouldUpdate
], LinksUI);
export { LinksUI };
